var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { CurrentOrderService } from './currentOrder.service';
import { Injectable } from '@angular/core';
var OrderValidation = (function () {
    function OrderValidation(currentOrderService) {
        var _this = this;
        this.currentOrderService = currentOrderService;
        this.validClass = 'fa fa-check';
        this.inValidClass = 'fa fa-circle-o';
        this.emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/i;
        this.currentOrderService.order.subscribe(function (order) { return _this.order = order; });
        this.currentOrderService.orderType.subscribe(function (orderType) { return _this.orderType = orderType; });
        this.currentOrderService.orderStep.subscribe(function (orderStep) { return _this.orderStep = orderStep; });
    }
    // OrderAddress Component validation section
    OrderValidation.prototype.getCompanyInformationFieldsClass = function () {
        var contact = this.order.Contact;
        if (contact.CompanyName == '' || contact.FirstName == '' || contact.LastName == ''
            || contact.Email == '' || !this.emailRegexp.test(contact.Email) || contact.Phone == '')
            return this.inValidClass;
        return this.validClass;
    };
    OrderValidation.prototype.getShippingAddressFieldsClass = function () {
        var addr = this.order.ShippingAddress;
        if (addr.Line && addr.City && addr.Country.Id && addr.PostalCode)
            return this.validClass;
        return this.inValidClass;
    };
    OrderValidation.prototype.getBillingAddressFieldsClass = function () {
        var addr = this.order.BillingAddress;
        if (this.order.IsBillingAddressSame == undefined)
            return this.inValidClass;
        else if (this.order.IsBillingAddressSame == false && addr.Line && addr.City
            && addr.Country.Id && addr.PostalCode) {
            return this.validClass;
        }
        else if (this.order.IsBillingAddressSame)
            return this.validClass;
        return this.inValidClass;
    };
    OrderValidation.prototype.isAddressValid = function () {
        if (this.orderType.lowercaseType == 'order')
            return this.isOrderAddressValid();
        else
            return this.isQuoteAddressValid();
    };
    OrderValidation.prototype.isOrderAddressValid = function () {
        if (this.getCompanyInformationFieldsClass() == this.validClass && this.getShippingAddressFieldsClass() == this.validClass &&
            this.getBillingAddressFieldsClass() == this.validClass && this.orderStep.partValidity)
            this.orderStep.addressValidity = true;
        else
            this.orderStep.addressValidity = false;
        return this.orderStep.addressValidity;
    };
    OrderValidation.prototype.isQuoteAddressValid = function () {
        if (this.getCompanyInformationFieldsClass() == this.validClass && this.getShippingAddressFieldsClass() == this.validClass && this.orderStep.partValidity)
            this.orderStep.addressValidity = true;
        else
            this.orderStep.addressValidity = false;
        return this.orderStep.addressValidity;
    };
    //OrderBilling Component validation section
    OrderValidation.prototype.getPurchaseOrderNumberFieldsClass = function () {
        if (this.order.PurchaseOrderNumber == '' || this.order.PurchaseOrderNumber == null)
            return this.inValidClass;
        return this.validClass;
    };
    OrderValidation.prototype.isBillingValid = function () {
        if (this.getPurchaseOrderNumberFieldsClass() == this.validClass && this.orderStep.addressValidity)
            this.orderStep.billingValidity = true;
        else
            this.orderStep.billingValidity = false;
        return this.orderStep.billingValidity;
    };
    // OrderShipping Component Validation section
    OrderValidation.prototype.getShippingMethodFieldsClass = function () {
        if (this.order.ShippingMethod == undefined || this.order.ShippingMethod == '')
            return this.inValidClass;
        else if (this.order.ShippingMethod == "other") {
            if (this.order.CourierName == '' || this.order.CourierAccountNumber == '')
                return this.inValidClass;
            else if (this.order.CourierName == 'Other' && this.order.OtherCourierName == '')
                return this.inValidClass;
        }
        return this.validClass;
    };
    OrderValidation.prototype.getDeliveryMethodFieldsClass = function () {
        if (this.order.DeliveryMethod == '')
            return this.inValidClass;
        return this.validClass;
    };
    OrderValidation.prototype.isShippingValid = function () {
        if (this.getShippingMethodFieldsClass() == this.validClass
            && this.getDeliveryMethodFieldsClass() == this.validClass && this.orderStep.billingValidity)
            this.orderStep.shippingValidity = true;
        else
            this.orderStep.shippingValidity = false;
        return this.orderStep.shippingValidity;
    };
    OrderValidation.prototype.getItemsFieldsClass = function () {
        if (typeof this.order.Items === 'undefined')
            return this.inValidClass;
        if (this.order.Items.length < 1)
            return this.inValidClass;
        for (var _i = 0, _a = this.order.Items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.PartNumber == '' || (item.Qty == undefined || item.Qty == NaN || item.Qty < 1))
                return this.inValidClass;
        }
        return this.validClass;
    };
    OrderValidation.prototype.isPartValid = function () {
        if (this.getItemsFieldsClass() == this.validClass)
            this.orderStep.partValidity = true;
        else
            this.orderStep.partValidity = false;
        return this.orderStep.partValidity;
    };
    OrderValidation.prototype.isOrderValid = function () {
        return this.orderStep.shippingValidity
            && (this.getItemsFieldsClass() != this.inValidClass);
    };
    OrderValidation.prototype.isQuoteValid = function () {
        return this.orderStep.partValidity && this.orderStep.addressValidity
            && (this.getItemsFieldsClass() != this.inValidClass);
    };
    OrderValidation.prototype.isEmailValid = function (email) {
        return this.emailRegexp.test(email);
    };
    OrderValidation = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [CurrentOrderService])
    ], OrderValidation);
    return OrderValidation;
}());
export { OrderValidation };
//# sourceMappingURL=orderValidation.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/orderValidation.js
// module id = 32
// module chunks = 0